import React from 'react';
import { Controller } from 'react-hook-form';
import FormControl from 'presentation/components/FormControl';
import { FormValidator } from 'tools/FormValidator';
import { useTranslation } from 'react-i18next';
import Input from 'presentation/components/Input';

interface CityFieldProps {
  formControl: any;
  errors: any;
  setValue: (name: 'street' | 'houseNr' | 'zip' | 'city', value: any) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
}

const CityField: React.FC<CityFieldProps> = ({ formControl, errors, inputRef }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'page.houseAddress'
  });

  return (
    <FormControl
      required
      additionalTestId="city"
      label={<span id="city-label">{t('labelCity')}</span>}
      error={errors.city && t('errorCity')}
      htmlFor="field-city"
    >
      <Controller
        name="city"
        control={formControl}
        rules={{
          required: true,
          validate: {
            validate: (v) => FormValidator.isValidCity(v)
          }
        }}
        render={({ field }) => (
          <Input
            id="field-city"
            type="text"
            aria-labelledby="city-label"
            aria-required="true"
            aria-invalid={!!errors.city}
            aria-describedby={errors.city ? 'city-error' : undefined}
            inputRef={inputRef}
            {...field}
          />
        )}
      />
    </FormControl>
  );
};

export default CityField;
